/**
 * Resolves a design-token shorthand to a CSS color value.
 *
 * @example resolveCssColor("grey-600") // "var(--grey-600)"
 * @example resolveCssColor("gvt-blue-500") // "var(--gvt-blue-500)"
 * @example resolveCssColor("var(--grey-600)") // unchanged
 */
export function resolveCssColor(value: string): string {
	const trimmed = value.trim();

	if (
		trimmed === "currentColor" ||
		trimmed.startsWith("var(") ||
		trimmed.startsWith("#") ||
		trimmed.startsWith("rgb") ||
		trimmed.startsWith("hsl")
	) {
		return trimmed;
	}

	const named: Record<string, string> = {
		white: "var(--white)",
		black: "var(--black)",
		primary: "var(--gvt-primary)",
		error: "var(--gvt-error)",
		warning: "var(--gvt-warning)",
		success: "var(--gvt-green)",
	};

	const lower = trimmed.toLowerCase();
	if (named[lower]) {
		return named[lower];
	}

	const greyCompact = /^grey(\d{3})$/.exec(lower);
	if (greyCompact) {
		return `var(--grey-${greyCompact[1]})`;
	}

	const kebab = /^(.+)-(\d+)$/.exec(trimmed);
	if (kebab) {
		return `var(--${kebab[1].toLowerCase()}-${kebab[2]})`;
	}

	return trimmed;
}
